module.exports = __webpack_public_path__ + "media/images/slider-img-02-ec0c21dd3c56dbaf396b06ac2130c6a0.jpg";